import * as Moment from 'moment'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/map'
import * as App from '../app'
import * as FlashMessage from '../components/flash-message'
import * as Constants from './constants'

const onEnter = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<any>,
  {window}: App.Dependencies,
) => action$
  .map(store.getState)
  .filter(({config}) => config.next_issue)
  .filter(({config}) => Boolean(Moment().isBetween(Moment(config.next_issue.cutoff).local(),
    Moment(config.next_issue.preprocess).local())))
  .filter(() => !store.getState().flash.message)
  .filter(() => window.sessionStorage.getItem(Constants.SHOW_CONTENT_EDIT_WINDOW_MESSAGE) !== 'false')
  .map(() => FlashMessage.showCustomMessage(Constants.CONTENT_EDIT_WINDOW_MESSAGE_TEXT,
    FlashMessage.FLASH_MESSAGE_COLOR))

const showCutoffBannerMessage = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<any>,
  {window}: App.Dependencies,
) => action$
  .map(store.getState)
  .filter(({config}) => config.next_issue)
  .filter(({config}) => Boolean(Moment().isBetween(Moment(config.next_issue.preprocess).local(),
    Moment(config.next_issue.send_at).local())))
  .filter(() => !store.getState().flash.message)
  .filter(() => window.sessionStorage.getItem(Constants.SHOW_CONTENT_CUTOFF_WINDOW_MESSAGE) !== 'false')
  .map(() => FlashMessage.showCustomMessage(Constants.CONTENT_CUTOFF_WINDOW_MESSAGE_TEXT,
    FlashMessage.FLASH_ERROR_COLOR))

const resetCutoffSessionStorage = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<any>,
  {window}: App.Dependencies,
) => action$
  .map(store.getState)
  .filter(({config}) => config.next_issue)
  .filter(({config}) => Boolean(!Moment().isBetween(Moment(config.next_issue.preprocess).local(),
    Moment(config.next_issue.send_at).local())))
  .filter(() => Boolean(window.sessionStorage.getItem(Constants.SHOW_CONTENT_CUTOFF_WINDOW_MESSAGE) !== 'true'))
  .do(() => window.sessionStorage.setItem(Constants.SHOW_CONTENT_CUTOFF_WINDOW_MESSAGE, 'true'))
  .map(() => ({type: ''}))

const resetSessionStorage = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<any>,
  {window}: App.Dependencies,
) => action$
  .map(store.getState)
  .filter(({config}) => config.next_issue)
  .filter(({config}) => Boolean(!Moment().isBetween(Moment(config.next_issue.cutoff).local(),
    Moment(config.next_issue.preprocess).local())))
  .filter(() => Boolean(window.sessionStorage.getItem(Constants.SHOW_CONTENT_EDIT_WINDOW_MESSAGE) !== 'true'))
  .do(() => window.sessionStorage.setItem(Constants.SHOW_CONTENT_EDIT_WINDOW_MESSAGE, 'true'))
  .mapTo({type: ''}) // why do I need an empty action?

const onContentEditWindowMessageDismiss = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<any>,
) => action$.ofType(FlashMessage.CLEAR_FLASH_MESSAGE)
  .map(store.getState)
  .filter(({flash}) => Boolean(flash.message === Constants.CONTENT_EDIT_WINDOW_MESSAGE_TEXT))
  .do(() => window.sessionStorage.setItem(Constants.SHOW_CONTENT_EDIT_WINDOW_MESSAGE, 'false'))
  .map(() => FlashMessage.clearFlash())

const onContentCutoffWindowMessageDismiss = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<any>,
) => action$.ofType(FlashMessage.CLEAR_FLASH_MESSAGE)
  .map(store.getState)
  .filter(({flash}) => Boolean(flash.message === Constants.CONTENT_CUTOFF_WINDOW_MESSAGE_TEXT))
  .do(() => window.sessionStorage.setItem(Constants.SHOW_CONTENT_CUTOFF_WINDOW_MESSAGE, 'false'))
  .map(() => FlashMessage.clearFlash())

export const epic = ReduxObservable.combineEpics(
  onContentCutoffWindowMessageDismiss,
  onContentEditWindowMessageDismiss,
  onEnter,
  resetSessionStorage,
  resetCutoffSessionStorage,
  showCutoffBannerMessage,
)



// WEBPACK FOOTER //
// ./src/config/epic.ts